import React, { Suspense, useEffect } from 'react';
import { renderRoutes } from 'react-router-config';
import PropTypes from 'prop-types';
import { LinearProgress } from '@material-ui/core';
import useStyles from './styles';
import { createStructuredSelector } from 'reselect';
import { isLoggedInSelector } from '../../appContainer/selectors';
import { useDispatch, useSelector } from 'react-redux';
import { validateTokenAction } from '../../appContainer/actions';
import AuthService from '../../services/auth.service';
import { useInjectReducer } from '../../store/injectReducer';
import reducer from '../../appContainer/reducer';
import LoginReducer from '../../views/Login/reducer';
import LoginSaga from '../../views/Login/saga';
import { useInjectSaga } from '../../store/injectSaga';
import saga from '../../appContainer/saga';

const stateSelector = createStructuredSelector({
  isLoggedIn: isLoggedInSelector,
});

const key = 'global';
const loginKey = 'login';

const GuestLayout = props => {
  const { route, location } = props;
  const classes = useStyles();
  const { isLoggedIn } = useSelector(stateSelector);
  const dispatch = useDispatch();

  useInjectReducer({ key, reducer });
  useInjectSaga({ key, saga });
  useInjectReducer({ key: loginKey, reducer: LoginReducer });
  useInjectSaga({ key: loginKey, saga: LoginSaga });

  useEffect(() => {
    const auth = new AuthService();
    const token = auth.getToken();
    const stopRedirect = (location?.pathname || "").includes("/ndr/")
    if (!isLoggedIn && token && !stopRedirect) {
      dispatch(validateTokenAction.Request({ token, redirect: true }));
    }
  }, [isLoggedIn]);

  return (
    <div className={classes.root}>
      {/* <TopBar className={classes.topBar} onOpenNavBarMobile={handleNavBarMobileOpen} /> */}
      <div className={classes.container}>
        {/* <NavBar className={classes.navBar} onMobileClose={handleNavBarMobileClose} openMobile={openNavBarMobile} /> */}
        <main className={classes.content}>
          <Suspense fallback={<LinearProgress/>}>{renderRoutes(route.routes)}</Suspense>
        </main>
      </div>
    </div>
  );
};

GuestLayout.propTypes = {
  route: PropTypes.object,
};

export default GuestLayout;
